export const menuItems = [
  {
    label: 'Services',
    path: '/services',
    children: [
      {
        label: 'HVAC Services',
        path: '/services/heating-and-air',
        children: [
          {
            label: 'Heating Services',
            path: '/services/heating-and-air/heating',
          },
          {
            label: 'Air Conditioning Services',
            path: '/services/heating-and-air/air-conditioning',
          },
          {
            label: 'Ductless Cooling & Heating',
            path: '/services/heating-and-air/cooling-and-heating',
          },
          {
            label: 'Mini-Split Installation',
            path: '/services/heating-and-air/ductless-ac-installation',
          },
          {
            label: 'AC Installation',
            path: '/services/heating-and-air/ac-installation',
          },
          {
            label: 'Heating Installation',
            path: '/services/heating-and-air/heating-installation',
          },
          {
            label: 'Heating Maintenance',
            path: '/services/heating-and-air/heating-maintenance',
          },
        ],
      },
      { label: 'Electrical', path: '/services/electrical' },
      { label: 'Plumbing', path: '/services/plumbing' },
      { label: 'Remodeling', path: '/services/remodeling' },
      { label: 'New Construction', path: '/services/construction' },
      { label: 'Real Estate Brokerage', path: '/services/brokerage' },
    ],
  },
  { label: 'Rebates', path: '/rebates', children: [] },
  { label: 'Testimonials', path: '/testimonials', children: [] },
  { label: 'Partners', path: '/partners', children: [] },
  { label: 'Contact Us', path: '/company/contact', children: [] },
  {
    label: 'About Us',
    path: '/company/about',
    children: [
      // { label: 'Contact Us', path: '/company/contact' },
      { label: 'Our Blog', path: '/blog' },
      { label: 'FAQ', path: '/company/faq' },
      { label: 'Careers', path: '/company/careers' },
    ],
  },
  /* {
    label: 'Blog',
    path: '/blog',
    children: [],
  }, */
];
